export const version = "4.0.7";
export const build = "esm";
//# sourceMappingURL=version.js.map
